import React, {useEffect, useState} from 'react';
import { useParams, useHistory } from 'react-router-dom'
import { useGetProject } from 'hooks/api/projects'
import { useGetOrder, useOrderComplete } from 'hooks/api/orders'
import SelectedProducts from './SelectedProducts'
import PanelTitle from 'components/elements/PanelTitle'
import Textarea from 'components/elements/form/Textarea'
import Panel from 'components/elements/Panel'
import Button from 'components/elements/Button'
import { toast } from 'react-toastify'

export default function OrderOverview() {
    const { projectId } = useParams()
    const history = useHistory()

    const [orderId, setOrderId] = useState<string>('')
    const [clientId, setClientId] = useState<number>(0)
    const [remarks, setRemarks] = useState<string>('')

    const [paymentMethod, setPaymentMethod] = useState<string>('invoice')
    const paymentMethods = [
        { id: 'invoice', title: 'Pay by invoice' },
        { id: 'mollie_ideal', title: 'iDeal' },
        { id: 'mollie_creditcard', title: 'Creditcard' },
        { id: 'mollie_paypal', title: 'PayPal' },
    ]

    const { data: dataProject } = useGetProject(projectId);
    const { data, isLoading } = useGetOrder(orderId);
    const { mutateAsync: patchOrderComplete, isLoading: loadingOrderCompletion } =
        useOrderComplete(data, remarks, paymentMethod, clientId)

    useEffect(() => {
        if(dataProject && dataProject.cart){
            setOrderId( dataProject.cart.token )
        }
        if(dataProject && dataProject.client){
            setClientId( dataProject.client.idPath.replace('/api/v2/shop/customers/', '') )
        }
    }, [dataProject])

    useEffect(() => {
        if (!data) return
        if (data.state !== 'parked' && data.state !== 'cart') {
            backToProjectOverview()
        }
    }, [data])

    const backToProjectOverview = () => {
        history.push(`/projects/${projectId}/overview`)
    }

    const goToOrderCompleted = () => {
        history.push(`/projects/${projectId}/order-completed`)
    }

    const completeOrder = () => {
        const orderItemWithoutVoice = data.items.find(item => !item.voice)
        if (orderItemWithoutVoice) {
            toast.error( `Order item '${orderItemWithoutVoice.reference}' has no voice selected` )
            return
        }
        patchOrderComplete().then((response: any) => {
            if (response.data.redirectUrl) {
                window.location.href = response.data.redirectUrl
                return
            }
            toast.success( 'Order succesfully completed' )
            goToOrderCompleted()
        })
    }

    const changePaymentMethod = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPaymentMethod(e.target.value)
    }


    return (
        <>
            {dataProject && <SelectedProducts order={data} voices={dataProject.voices} setShowProductAdd={null} isLoading={isLoading}></SelectedProducts>}
            <Panel className="px-0">
                <div className="px-8 pb-4 border-b border-gray-200">
                    <PanelTitle>Add remarks for the order</PanelTitle>
                </div>
                <div className="px-8 pt-5">
                    <Textarea label="Your order remarks" value={remarks} onChange={(e) => setRemarks(e.target.value)}></Textarea>
                </div>
            </Panel>
            <Panel className="px-0">
                <div className="px-8 pb-4 border-b border-gray-200">
                    <PanelTitle>Choose payment method</PanelTitle>
                </div>
                <div className="px-8 pt-5">
                    <fieldset>
                        <div className="space-y-2 sm:flex sm:items-center sm:space-y-0 sm:space-x-10">
                            {paymentMethods.map((method) => (
                                <div key={method.id} className="flex items-center">
                                    <input
                                        onChange={changePaymentMethod}
                                        defaultChecked={method.id === paymentMethod}
                                        id={method.id}
                                        value={method.id}
                                        name="payment-method"
                                        type="radio"
                                        className="relative size-4 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white not-checked:before:hidden focus:bg-cobalt-500 focus:ring-transparent focus:checked:bg-cobalt-500 checked:border-cobalt-400 checked:active:bg-cobalt-500  checked:bg-cobalt-400 disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden"
                                    />
                                    <label htmlFor={method.id} className="ml-2 flex items-center text-sm text-gray-700">
                                        <figure className="w-10 relative inline-block ">
                                            <img src={`/assets/images/payment-method/${method.id}.svg`} alt={`${method.title} logo`}/>
                                        </figure>
                                        <span>{method.title}</span>
                                    </label>
                                </div>
                            ))}
                        </div>
                    </fieldset>
                </div>
            </Panel>
            <div className="flex justify-end gap-2">
                <Button type="outline" onClick={backToProjectOverview}>Back</Button>
                <Button onClick={completeOrder} loading={loadingOrderCompletion}>Confirm order</Button>
            </div>
        </>
    )
}
